import type { SponsorPlanDiscountInfo } from '@app/_proto/Protos/sponsors';
import { decimalToNumber } from '@app/libs/utils';
import { formatAmountForDisplay } from '@app/utils/utils';
import type { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
    price: number;
    discountInfo?: SponsorPlanDiscountInfo | undefined;
    withDiscountDurationWarning?: boolean | undefined;
    priceProps?: HTMLAttributes<HTMLElement>;
    discountedPriceProps?: HTMLAttributes<HTMLElement>;
    durationProps?: HTMLAttributes<HTMLElement>;
};

export default function ChampionPlanPriceInfo({
    price,
    discountInfo,
    withDiscountDurationWarning,
    priceProps,
    discountedPriceProps,
    durationProps,
}: Props) {
    const discountedPrice = discountInfo?.discountedPrice ? decimalToNumber(discountInfo?.discountedPrice) : undefined;

    return (
        <>
            <span {...priceProps}>{formatAmountForDisplay(discountedPrice ?? price)}</span>
            {discountedPrice !== undefined && (
                <>
                    {' '}
                    <span
                        {...discountedPriceProps}
                        className={twMerge('line-through', discountedPriceProps?.className)}
                    >
                        {formatAmountForDisplay(price)}
                    </span>
                </>
            )}
            <span {...durationProps} className={twMerge('whitespace-nowrap', durationProps?.className)}>
                {' / '}
                {withDiscountDurationWarning && discountedPrice !== undefined ? '1st month' : 'month'}
            </span>
        </>
    );
}
